import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useValueRef, useElementForkRef } from '@cian/react-utils';
/**
 * Компонента для обработки клика снаружи children
 *
 * Умеет принимать ссылки на дополнительные DOM-ноды которые не будут считаться наружними
 *
 * Не рендерит дополнительных элементов и оберток
 *
 * @export
 * @param {IOutsideProps} props
 * @returns
 */
export function Outside(props) {
  /**
   * Запоминаем пропсы для того чтобы не переподписываться на клик
   * Переподписка может нарушить порядок вызова обработчиков относительно React-дерева
   * Это просто нежелательно
   */
  var propsRef = useValueRef(props);
  var _useElementForkRef = useElementForkRef(props.children),
    _useElementForkRef2 = _slicedToArray(_useElementForkRef, 2),
    children = _useElementForkRef2[0],
    childrenRef = _useElementForkRef2[1];
  React.useEffect(function () {
    var handleDocumentClick = function handleDocumentClick(event) {
      var currentProps = propsRef.current;
      if (!currentProps.active) {
        return;
      }
      var isInside = [childrenRef].concat(_toConsumableArray(currentProps.insideRefs)).some(function (_ref) {
        var current = _ref.current;
        return current && current.contains(event.target);
      });
      if (!isInside && currentProps.active) {
        currentProps.onOutside();
      }
    };
    document.addEventListener('click', handleDocumentClick);
    return function () {
      document.removeEventListener('click', handleDocumentClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return children;
}
Outside.defaultProps = {
  active: true,
  insideRefs: []
};